import { IClassObject } from './app.interface';
import firebase from 'firebase/compat/app';

export interface IFirebaseLogin extends IClassObject {
  user_credential?: firebase.auth.UserCredential;
}

export interface IFirebaseRegister extends IClassObject {
  user_credential?: firebase.auth.UserCredential;
}

export interface IEmailAuth {
  email: string;
  pass_validation: boolean;
  success: boolean;
}
